import { render, staticRenderFns } from "./VehicleTrimComponent.vue?vue&type=template&id=284d7319"
import script from "./VehicleTrimComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleTrimComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports